import { FolderWorkflowStepsSnapshot } from '../server/folder-workflow-steps-snapshot';

export class WorkflowSectionRefreshEvent {
    public constructor(
        public folderId: string,
        public workflowStepsSnapshot: FolderWorkflowStepsSnapshot[]
    ) {}
}
